import { render } from "./indexMaritalStatusesComponent.vue?vue&type=template&id=749952de"
import script from "./indexMaritalStatusesComponent.vue?vue&type=script&lang=js"
export * from "./indexMaritalStatusesComponent.vue?vue&type=script&lang=js"

import "./indexMaritalStatusesComponent.vue?vue&type=style&index=0&id=749952de&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__